import React from "react";
import { Link, useLocation } from "react-router-dom";
import AnchorLink from "react-anchor-link-smooth-scroll";

// import styled components
import { NavItemContainer } from "./styled";

const RouterNavItem = (props) => {
  // Check if we're already on the home page
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <NavItemContainer>
      {isHomePage && props.target ? (
        // If we're on home page and it's a target link, use AnchorLink
        <AnchorLink href={`#nav-${props.target}`}>{props.label}</AnchorLink>
      ) : props.to ? (
        // If it's a route link, use Link
        <Link to={props.to}>{props.label}</Link>
      ) : (
        // If we're not on home page but it's a target link, link to home with hash
        <Link to={`/#nav-${props.target}`}>{props.label}</Link>
      )}
    </NavItemContainer>
  );
};

export default RouterNavItem;
